var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "25",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.45 19.62c1.23 1.5 2 3.38 2.1 5.44h-1.86a7.39 7.39 0 0 0-1.56-4.12l1.32-1.32zm-.97-1l-1.31 1.3a7.4 7.4 0 0 0-3.96-1.77v-1.87a9.24 9.24 0 0 1 5.27 2.33zm3.04 7.83a9.28 9.28 0 1 1-9.7-10.2v1.86a7.43 7.43 0 1 0 7.83 8.34h1.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28 24.04v-.02l.1-.05c.09-.06.17-.1.26-.14l4.4-2.27-2.28 4.4c-.03.08-.08.17-.13.25l-.06.11-.01-.01-.15.18a1.62 1.62 0 1 1-2.13-2.45z"
  }))));
});